<template>
    <div>
        <top :keyword="''" @mouse-enter="showCategory += 1" @mouse-leave="showCategory -= 1"></top>
        <category :category="category" :subCategory="subCategory" :showCategory="showCategory"></category>

        <section id="carousel" class="index-carousel">
            <ul id="topBanner" style="padding-top: 5px;" class="slide">
                <li
                    v-for="(imgUrl, index) in bannerList"
                    v-show="index===mark"
                    :key="index"
                    class="slideshow"
                    @mouseenter="stop"
                    @mouseleave="go"
                >
                    <pic :src="imgUrl" style="width:100%;height:500px;" />
                </li>
                <li class="bar" v-if='bannerList.length > 1'>
                    <span
                        v-for="(item, index) in bannerList"
                        :class="{ 'active':index===mark }"
                        :key="index"
                        @mouseenter="change(index)"
                        @mouseleave="go"
                    ></span>
                </li>
            </ul>
        </section>
        <!--头部广告1-->
        <section class="con02" v-for="(c) in mianViewClassify" :id="c.id" :key="c.id">
            <div class="page-width animated fadeInUp">
                <div class="index-title">
                    <router-link
                        :to="{'name': 'courseList', 'params': {'id': c.id, 'category': c, 'children': subCategory[c.id]}}"
                    >
                        <span class="more">更多</span>
                    </router-link>
                    <h4>{{ c.name }}</h4>
                    <span class="nav-name-info fl c-b1">
                        <a
                            v-for="(s,index) in subCategory[c.id]"
                            v-if="index<5"
                            :key="s.id"
                            :id="s.id"
                            style="cursor: pointer"
                            :class="{'curr': activeSubClassify[c.id] == s.id}"
                            @click="changeActive(c.id, s.id)"
                        >{{ s.name }}</a>
                    </span>
                </div>
                <div class="clearfix">
                    <ul>
                        <courseLi :course="course" v-for="course in courses[c.id]" :key="course.id"></courseLi>
                    </ul>
                </div>
            </div>
        </section>
        <bottom></bottom>
        <div class="rightwxcode">
            <div class="wxcode" v-for='(item,index) in codeImgList' :key='index'>
                <a :href="item.linkUrl" :target='item.state'>
                    <pic v-if='item.picUrl' :src="item.picUrl" alt />
                    <span v-if='item.promptText' style="font-size:12px;">{{item.promptText}}</span>
                </a>
            </div>
        </div>
    </div>
</template>
<script>
import top from './top'
import category from './categoryView'
import bottom from './bottom'
import courseLi from '../components/courseLi'

export default {
    name: 'index',
    data() {
        return {
            showList: false,
            category: [],
            subCategory: {},
            courses: {},
            activeSubClassify: {},
            bannerList: this.$store.getters.banner,
            mark: 0,
            showCategory: 0,
            codeImgList:[]
        }
    },
    computed: {
        mianViewClassify: function() {
            var temp = []
            for (let i = 0; i < this.category.length; i++) {
                temp.push(this.category[i])
            }
            return temp
        }
    },
    methods: {
        go() {
            this.timer = setInterval(() => {
                this.autoPlay()
            }, 3000)
        },
        stop() {
            clearInterval(this.timer)
            this.timer = null
        },
        change(index) {
            this.mark = index
            this.stop()
        },
        getCodeImg(){
            let id = this.$store.getters.platform.id
            this.$http
            .get(this.$cmsPath + '/platform/api/'+ id + '/floating')
            .then(function(res) {
                this.codeImgList = res.body.data.reverse()
                this.codeImgList.map(item => {
                    if(item.linkUrl == ''){
                        item.linkUrl = 'javascript:;'
                    }else{
                        item.state = '_blank'
                    }
                })
            })
        },
        init(data) {
            this.category = data.root
            this.subCategory = data.data
            for (const c of this.mianViewClassify) {
                let temp = []
                temp.push(c.id)
                for (const sub of this.subCategory[c.id] || []) {
                    temp.push(sub.id)
                }
                this.loadCourses(c.id, temp.join(','))
            }
        },
        loadCourses(categoryId, categoryIds) {
            var _this = this
            this.$http
                .get(
                    this.$coursePath +
                        '/index/courses?categoryIds=' +
                        categoryIds
                )
                .then(function(result) {
                    if (result.data.code == 0) {
                        _this.courses[categoryId] = result.data.data.courses
                        _this.courses = JSON.parse(
                            JSON.stringify(_this.courses)
                        )
                    }
                })
        },
        changeActive(categoryId, subId) {
            let categoryIds = []
            if (this.activeSubClassify[categoryId] !== subId) {
                this.activeSubClassify[categoryId] = subId
                categoryIds.push(subId)
            } else {
                delete this.activeSubClassify[categoryId]
                categoryIds.push(categoryId)
                for (const sub of this.subCategory[categoryId] || []) {
                    categoryIds.push(sub.id)
                }
            }
            this.activeSubClassify = JSON.parse(
                JSON.stringify(this.activeSubClassify)
            )
            this.loadCourses(categoryId, categoryIds.join(','))
        },
        autoPlay() {
            this.mark++
            if (this.mark > this.bannerList.length - 1) {
                this.mark = 0
            }
        },
        getBanner(){
            let id = this.$store.getters.platform.id
            this.$http
            .get(this.$cmsPath + '/platform/api/'+ id + '/banner')
            .then(function(res) {
                if(res.data.data.length > 0){
                    this.bannerList = res.data.data
                    this.$store.commit('setBanner', res.data.data)
                }
            })
        }
    },
    created() {
        // this.getReitem()
        var _this = this
        this.$http
            .get(this.$coursePath + '/index/training/categories')
            .then(function(result) {
                if (result.data.code == 0) {
                    _this.init(result.data.data)
                } else {
                    alert(result.data.message)
                }
            })
        this.getCodeImg()
        this.getBanner()
        this.$nextTick(() => {
            this.timer = setInterval(() => {
                this.autoPlay()
            }, 3000)
        })
    },
    components: {
        courseLi: courseLi,
        bottom: bottom,
        top: top,
        category
    }
}
</script>
<style scoped>
@import '../assets/css/iconfont.css';
@import '../assets/css/common.css';
@import '../assets/css/index.css';
.rightwxcode{
    position: fixed;
    bottom: 30px;
    right: 20px;
    width: 150px;
    height: auto;
}
.wxcode {
    width: 150px;
    height: auto;
    margin-bottom: 10px;
    background: #fff;
    padding: 10px 0;
}
.wxcode a{
    width: 150px;
    height: 100%;
    background: #fff;
    text-align: center;
}
.wxcode a:hover{
    cursor: pointer;
}
.wxcode a img {
    width: 150px;
    height: 150px;
}
.wxcode a span {
    color: #333;
}
.slide {
    padding: 0 !important;
    width: 100%;
    height: 500px;
    margin: 0 auto;
    overflow: hidden;
    position: relative;
}
.slideshow {
    width: 100%;
    height: 100%;
}
.bar {
    position: absolute;
    width: 100%;
    bottom: 10px;
    margin: 0 auto;
    z-index: 10;
    text-align: center;
}
.bar span {
    width: 30px;
    height: 5px;
    background: white;
    display: inline-block;
    margin-right: 10px;
}
.bar .active {
    background: #3ab57e !important;
}
</style>



// WEBPACK FOOTER //
// src/views/index.vue